"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../../styled-components");
const Base_1 = require("../Base");
const Unlicensed = ({ size = 20, title = "Unlicensed", fill, }) => {
    const theme = (0, styled_components_1.useTheme)();
    fill = fill || theme.icon;
    return (react_1.default.createElement(Base_1.Base, { smooth: true, size: size, fill: fill, title: title },
        react_1.default.createElement("path", { d: "M4,15L4,9.7C3.3,9.9 2.1,10.6 1.8,10.2 1.3,9.7 2.6,8.1 2.3,7.5 2.1,6.9 0,6.6 0,6 0,5.4 2.1,5.1 2.3,4.5 2.6,3.9 1.3,2.2 1.8,1.8 2.3,1.3 3.9,2.6 4.5,2.3 5.1,2.1 5.4,-8.88178419700125E-16 6,-8.88178419700125E-16 6.6,-8.88178419700125E-16 6.9,2.1 7.5,2.3 8.1,2.6 9.8,1.3 10.2,1.8 10.6,2.3 9.4,3.9 9.7,4.5 9.9,5.1 12,5.4 12,6L9.2,6 9,6.2C9,6.2 9,6 9,6 9,4.3 7.7,3 6,3 4.3,3 3,4.3 3,6 3,7.7 4.3,9 6,9 7.7,9 6.2,9 6.2,9L6,9.2 6,13 4,15z" }),
        react_1.default.createElement("path", { opacity: "0.5", d: "M6,9C4.3,9 3,7.7 3,6 3,4.3 4.3,3 6,3 7.7,3 9,4.3 9,6 9,7.7 9,6.2 9,6.2L6.3,8.9C6.3,8.9,6.1,8.9,6.1,8.9z" }),
        react_1.default.createElement("path", { fill: "#FF626D", d: "M13.4,7L9.7,7 7.1,9.6 7.1,13.3 9.7,15.9 13.4,15.9 16,13.3 16,9.6 13.4,7z M12.1,14.1L10.8,14.1 10.8,12.8 12.1,12.8 12.1,14.1z M12.1,12.1L10.8,12.1 10.8,8.9 12.1,8.9 12.1,12.1z" })));
};
exports.default = Unlicensed;
//# sourceMappingURL=index.js.map